import React, { useState } from 'react'
import './Gender.css'

const GENDER_API = "https://api.genderize.io"

const Gender = () => {
    const [name, setName] = useState("")
    const [data, setData] = useState("")
    const [show, setShow] = useState(false)
    const [userName, setUserName] = useState("")

    const fetchData = () => {
        fetch(`${GENDER_API}?name=${name}`)
            .then(response => response.json())
            .then(json =>
                setData(json));
        setUserName(name)
        setShow(true)
        setName("")
    }

    const alert_name = () => {
        return (
            alert("please enter your name to continue")
               )
    }

const showData = (e) => {
    e.preventDefault()
    {
        name ? fetchData() : alert_name()
    }

}

const inputChange = (e) => {
    setName(e.target.value)
    setShow(false)
}

return (
    <div className="gender">
        <form onSubmit={showData} >
            <span>Name</span><input type="text" value={name} onChange={inputChange} /><br />
            <button type="submit">Click for Results</button>
        </form>
        <div className="results">
            {show ? <h2>hello {userName},According to me, there is a {(data.probability) * 100} % probability that you are  {data.gender} . and there are more than {(data.count) * 542} number of people with the name "{userName}" and who are "{data.gender}" </h2> : <h2>The result will be displayed here</h2>}
        </div>


    </div>


)
}

export default Gender
